// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class ZoneResource extends Resource {
    basePath: string = 'sites/sites/{parent}/zones/';

    objectPath: string = 'sites/sites/{parent}/zones/{ident}/';
}
